/* AI Infra Directory theme JS */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Mobile nav toggle */
    var burger = document.querySelector('.ai-burger');
    var mnav = document.querySelector('.ai-mnav');
    if (burger && mnav) {
      burger.addEventListener('click', function () {
        mnav.classList.toggle('open');
      });
    }

    /* Header active link */
    var path = location.pathname.replace(/\/+$/, '') || '/';
    document.querySelectorAll('.ai-nav a, .ai-mnav a').forEach(function (a) {
      var href = (a.getAttribute('href') || '').replace(/\/+$/, '');
      if (href === path || (href.length > 1 && path.indexOf(href) === 0)) a.classList.add('active');
    });

    /* Collection sort select */
    var sortSel = document.querySelector('[data-sort]');
    if (sortSel) {
      sortSel.addEventListener('change', function () {
        var url = new URL(location.href);
        url.searchParams.set('sort_by', sortSel.value);
        location.href = url.toString();
      });
    }

    /* Quantity stepper on product page */
    var qty = document.querySelector('[data-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value || '1', 10) || 1;
          if (btn.getAttribute('data-step') === '-1') v = Math.max(1, v - 1);
          else v += 1;
          input.value = v;
        });
      });
    }

    /* Quote form prefill: /pages/request-a-quote?product=<name>&subject=<free text> */
    if (window.AIC && location.pathname.indexOf('request-a-quote') !== -1) {
      var params = new URLSearchParams(location.search);
      var prod = params.get('product') || '';
      if (prod) {
        try { prod = decodeURIComponent(prod); } catch (e) { /* keep raw */ }
        var sel = document.querySelector('[data-quote-product]');
        if (sel) sel.value = prod;
      }
      var subj = params.get('subject');
      if (subj && !prod) {
        var s2 = document.querySelector('[data-quote-product]');
        if (s2) { try { s2.value = decodeURIComponent(subj); } catch (e) { s2.value = subj; } }
      }
    }

    /* add-to-cart form tiny feedback */
    document.querySelectorAll('form[data-aic-add]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var b = f.querySelector('[type="submit"]');
        if (b) { b.disabled = true; b.textContent = 'Adding…'; }
      });
    });
  });
})();
